import styled, { css } from 'styled-components';

export interface SpacerProps {
  spacing: number;
  vertical?: boolean;
}

/**
 * @render react
 * @name Spacer component
 * @description Spacer component.
 * @example
 *  <Spacer spacing={24} />
 */

const Spacer = styled.div<SpacerProps>`
  ${({ spacing, vertical }) =>
    vertical
      ? css`
          width: ${spacing}px;
        `
      : css`
          height: ${spacing}px;
        `}
`;

export default Spacer;
